import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { OkcancelDialogComponent } from 'src/app/shared/components/okcancel-dialog/okcancel-dialog.component';
import { AppstyleService } from 'src/core/appstyle/appstyle.service';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { Atencion } from 'src/core/atencion/atencion.types';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta, RequestConsultaReagandarCita } from 'src/core/consulta/consulta.types';
import { MascotaService } from 'src/core/mascota/mascota.service';
import { Mascota } from 'src/core/mascota/mascota.types';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';
import { VeterinariaService } from 'src/core/veterinaria/veterianaria.service';
import { ResponseHorasVeterinaria, Veterinaria } from 'src/core/veterinaria/veterinaria.types';
import * as moment from 'moment';


@Component({
  selector: 'app-agendar-cita',
  templateUrl: './agendar-cita.component.html',
  styleUrls: ['./agendar-cita.component.css'],
})
export class AgendarCitaComponent extends CommonComponent implements OnInit{
  selected: Date | null;
  currentDate: Date = new Date();
  horas = [];
  horasVet = [];
  nuevaConsulta: Consulta;
  reAgandarConsulta: RequestConsultaReagandarCita;
  updatedConsulta: Consulta;
  @ViewChild('crearConsultaNgForm') crearConsultaNgForm: NgForm;
  userSession: User;
  veterinaria: Veterinaria;
  crearConsultaForm: UntypedFormGroup;
  atenciones: Atencion[] = [];
  atencionSelected: Atencion;
  mascotasUsuario: Mascota[];
  mascotaSelected: Mascota;
  horaSelected = -1;
  reagendar = null;

  constructor(
    private _styleService: AppstyleService,
    private _formBuilder: UntypedFormBuilder,
    private _consultaService: ConsultaService,
    private _userService: UserService,
    private _veterinarioService: VeterinariaService,
    private _atencionService: AtencionService,
    private _mascotaService: MascotaService,
    private _route: Router,
    private route: ActivatedRoute,
    public _dialog: MatDialog,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
    this._styleService.backgroudcolor = 'bg-pet-cli-color-6';

  }

  ngOnInit(): void {
    this.crearConsultaForm = this._formBuilder.group({
      fechaCita:[null,Validators.required],
      horaCita:[null,Validators.required],
      idAtencion: [null,Validators.required],
    });
    this.reagendar = this.route.snapshot.paramMap.get('id');
    // console.log("reschedule, this.reagendar: ",this.reagendar);
    
    if(this.reagendar === "reschedule"){
      this.route.queryParams.subscribe(params => {
        this.reAgandarConsulta = {
          id : params['consultaId'],
          fechaReagendarCita : '',
          horaReagendarCita : ''
        };

       console.log('parametro recibidos: ',this.reAgandarConsulta );
       
    });
      this.getConsultaToUpdate();
    }else{
      this.getUserSession();
      console.log('----- '+this.crearConsultaNgForm);
      
      this.getAtenciones(this.veterinaria.id );
    }
  }

  getConsultaToUpdate(){
    this._consultaService.Consulta$.subscribe({
      next: (consulta: Consulta) => {

        this._veterinarioService.veterinarias$.subscribe({
          next: (vets: Veterinaria[]) => {
            vets.forEach((vet) => {
              if(vet.id === consulta.veterinarioId){
                this._veterinarioService.veterinaria=vet;
                this.getUserSession();
                this.getAtenciones(1);
              }
            });

          }
        });

        this.updatedConsulta = consulta;
        this.crearConsultaForm.get('idAtencion').setValue(consulta.consultaIdAtencion);
      },
      error: () => {}
    });
  }

  getMascotasUsuario(){
    this._mascotaService.getMascotasByUser(this.userSession.id).subscribe({
      next: (response: Mascota[]) => {
        this.mascotasUsuario = response;
      },
      error: () => {}
    });
  }

  getAtenciones(idVeterinaria:number){
    this._atencionService.getAtencionesPorVeterinaria(idVeterinaria).subscribe({
      next: (response: Atencion[]) => {
        this.atenciones = response;
      },
      error: (error: any) => {
        console.log('error : ', error);
      }
    });
  }

  getUserSession(){
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
        this.getMascotasUsuario();
        this.getVeterinaria();
      }
    });
  }

  getVeterinaria(){
    this._veterinarioService.veterinaria$.subscribe({
      next: (vet: Veterinaria) => {
        if (vet === null){
          this._route.navigate(['../']);
          return;
        }
        this.veterinaria = vet;
        this.nuevaConsulta = {
          idUsuario: this.userSession.id,
          idVeterinario: this.veterinaria.id,
          tiempoEstimadoConsulta:'00:40:00',
          estadoCita:2,
          costoConsulta:25000,
        } as Consulta;
        const now = new Date();
        now.setHours(0,0,0,0);
        this.getHOrasOcupadasByFecha(now);
      },
      error: (error: any) => {
        //this._route.navigate(['/client/home']);
        console.log(error);
      }
    });
  }

  getHOrasOcupadasByFecha(event){
    var fecha = event;
    this.horaSelected = -1;
    this.crearConsultaForm?.get('horaCita').setValue(null);
    if(fecha){
      this.selected = fecha;
      fecha = fecha.toISOString().split('T')[0];
      this.crearConsultaForm?.get('fechaCita').setValue(fecha);
      this._veterinarioService.getHorasOcupadasByFecha(fecha, this.veterinaria.id).subscribe({
        next: (response: ResponseHorasVeterinaria[]) => {
          this.horasVet = response;
          this.horas = this.generarHoras('08:00:00','17:00:00', response.map(objeto => objeto.horaCita) );
        },
        error: (error: any) => {
          console.log(error);
        }
      });
    }

  }

  generarHoras(rangoInicio, rangoFin, horasOcupadas: string[]) {
    const horas = [];
    const inicio = new Date('2000-01-01 ' + rangoInicio);
    const fin = new Date('2000-01-01 ' + rangoFin);
    for (let hora = inicio; hora <= fin; hora.setHours(hora.getHours() + 1)) {
        const horaFormato24 = hora.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false});
        const horaFormato12 = hora.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: true});
        if (horasOcupadas.includes(horaFormato24)){
          horas.push({hora:horaFormato12, hora24:horaFormato24, ocupada: true});
        }else{
          horas.push({hora:horaFormato12, hora24:horaFormato24, ocupada: false});
        }
    }
    return horas;
  }

  agendarCita(){
    this.nuevaConsulta.idAtencionConsultaDto = +this.nuevaConsulta.idAtencionConsultaDto;
      this._consultaService.createConsulta(this.nuevaConsulta).subscribe({
        next: (response: Consulta) => {
          const snakREf = this.openSnackBar('Se ha completado exitosamente la programación de su cita. Le solicitamos aguardar pacientemente hasta que el equipo veterinario confirme su solicitud, momento en el cual podrá proceder con el pago. ¡Gracias por confiar en nuestros servicios!', 20, 'success');
          snakREf.afterDismissed().subscribe(() => {
            this._route.navigate(['/client/home']);
            setTimeout(() => {
              window.location.reload();
            }, 100);
          });
        },
        error: (error: any) => {
          console.log('error : ', error);
        }
      });

  }

  mascotaSelect(value){
    this.mascotaSelected = this.mascotasUsuario.find(objeto => +objeto.idMascota === +value);
  }

  atencionSelect(value){
    this.atencionSelected = this.atenciones.find(objeto => +objeto.id === +value);
  }

  solicitarReagendamiento(){
    const now = new Date();
    const fechaNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const horaNow = moment();
    
    if (this.crearConsultaForm.valid) {
      // FORMULARIO COMPLETO -- VALIDACINOES INICIO
      // console.log('OK- FECHA ACTUAL: ',fechaNow);
      const horaSeleccionada = moment(String(this.crearConsultaForm.get('horaCita').value), 'HH:mm:ss');
      
      const fechaSeleccionada = new Date(Date.parse(this.crearConsultaForm.get('fechaCita').value)+ (5 * 60 * 60 * 1000));

      // console.log('OK- FECHA DE FORMULARIO :',this.crearConsultaForm.get('fechaCita').value);
      // console.log('OK- FECHA SELECCION: ',fechaSeleccionada);

      // console.log('OK- fechaSeleccionada >= fechaNow ', fechaSeleccionada >= fechaNow );
      
      if(fechaSeleccionada >= fechaNow ){
        // console.log("\nfechaNow === fechaSeleccionada:" ,  moment(fechaNow).isSame(fechaSeleccionada));
        // console.log("\nhoraNow.isBefore(horaSeleccionada",!horaNow.isBefore(horaSeleccionada) );
        
        if(  moment(fechaNow).isSame(fechaSeleccionada) && !horaNow.isBefore(horaSeleccionada) ){
          // console.log("OK- Hora seleccionada ya pasada");
          // console.log('OK- ES EL MISMO DÍA A HORA NO PERMITIDA');  
          this.fechaSeleccionadaNoValida();
        }else{
          
          const message = `Seguro de reagendar su cita para ${this.crearConsultaForm.get('fechaCita').value} a las  ${this.crearConsultaForm.get('horaCita').value}
          \n NOTA: Recuerde que si su reagendamiento es rechazado, la veterinaria deberá contactarse para realizar el proceso de reagendamiento.\n 
          Dicho proceso no será reflejado en la plataforma `;
          const dialogRef = this._dialog.open(OkcancelDialogComponent, {
            panelClass: ['rounded-lg'],
            data: {message: message}
          });
          dialogRef.afterClosed().subscribe(result => {
            if(result){
              this.reAgandarConsulta.fechaReagendarCita =this.crearConsultaForm.get('fechaCita').value;
              this.reAgandarConsulta.horaReagendarCita =this.crearConsultaForm.get('horaCita').value;
              // console.log("objeto de reagandar : ",this.reAgandarConsulta);
              this.solicitarReagandar();
            }
          });
      
        }
        // FORMULARIO COMPLETO -- VALIDACINOES FINS
      }else{
        console.log('fecha no permitida fecha ya pasada');  
        this.fechaSeleccionadaNoValida();
      }

    }else{      
      const message = `POR FAVOR: \n Seleccione hora y fecha de su reagendamiento`;
      const dialogRef = this._dialog.open(OkcancelDialogComponent, {
        panelClass: ['rounded-lg'],
        data: {message: message}
      }).afterClosed().subscribe();
    }
  }

  async solicitarReagandar(){
    this.nuevaConsulta.idAtencionConsultaDto = +this.nuevaConsulta.idAtencionConsultaDto;
      await this._consultaService.solicitarReagendamiento(this.reAgandarConsulta).subscribe({
        next: (response: Consulta) => {
          const snakREf = this.openSnackBar('Se ha completado exitosamente la programación de su cita. Le solicitamos aguardar pacientemente hasta que el equipo veterinario confirme su solicitud, momento en el cual podrá proceder con el pago. ¡Gracias por confiar en nuestros servicios!', 20, 'success');
          snakREf.afterDismissed().subscribe(() => {
            this._route.navigate(['/client/home']);
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          });
        },
        error: (error: any) => {
          console.log('error : ', error);
        }
      });
      

  }
  
  confirmDats(){
    if (this.crearConsultaForm.valid) {
      this.nuevaConsulta.fechaCita = this.crearConsultaForm.get('fechaCita').value;
      this.nuevaConsulta.horaCita = this.crearConsultaForm.get('horaCita').value;
      this.nuevaConsulta.idAtencionConsultaDto = this.crearConsultaForm.get('idAtencion').value;
      this.nuevaConsulta.costoConsulta = this.atencionSelected.valor;
      // console.log('atencion : ', this.nuevaConsulta);

      const message = `Confirmar la cita para el ${this.nuevaConsulta.fechaCita} a las ${this.nuevaConsulta.horaCita} con un costo de consulta de $ ${this.nuevaConsulta.costoConsulta}`;
      const dialogRef = this._dialog.open(OkcancelDialogComponent, {
        panelClass: ['rounded-lg'],
        data: {message: message}
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result){
          this.agendarCita();
        }
      });
    }else{
      console.log('datos incompletos');
    }
  }

  private fechaSeleccionadaNoValida(){
    const message = `Parece que la fecha que elegiste ya no esta disponible\n`;
    const dialogRef = this._dialog.open(OkcancelDialogComponent, {
      panelClass: ['rounded-lg'],
      data: {message: message}
    }).afterClosed().subscribe();
  }
}
